import React from 'react'
import { JsonLd } from 'react-schemaorg'
import { BreadcrumbList } from 'schema-dts'
import { useStoreConfig } from 'lib/core/hooks'
import { BreadcrumbItem } from 'lib/core/hooks/useBreadcrumbs'
import { useHistory } from 'react-router-dom'

interface Props {
  breadcrumbItems: BreadcrumbItem[]
}

export const JsonLdBreadcrumbs = ({ breadcrumbItems }: Props) => {
  const history = useHistory()
  const { pwaUrl } = useStoreConfig()

  return (
    <JsonLd<BreadcrumbList>
      item={{
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: breadcrumbItems.map((item, index) => {
          return {
            '@type': 'ListItem',
            position: index + 1,
            item: {
              '@id': `${pwaUrl ?? ''}/${item.route ?? history.location.pathname.substr(1)}`,
              name: item.name
            }
          }
        })
      }}
    />
  )
}
